import React from "react";
import { VictoryContainer, VictoryLabel, VictoryPie } from "victory";
import Box from "../Box";
import { formatPercentage } from "../../utils/numberUtils";

type RatePieChartProps = {
  auditPercentage: number;
};

const RatePieChart = ({ auditPercentage }: RatePieChartProps) => {
  const tabColor = ["#0970E6" /*green-medium*/, "#E5E9F0"];
  const tabData = [
    {
      key: "",
      y: auditPercentage,
    },

    {
      key: "",
      y: 100 - auditPercentage,
    },
  ];

  const valueNPS = auditPercentage
    ? formatPercentage(auditPercentage, "")
    : "-";

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <VictoryContainer
        height={200}
        responsive={false}
        style={{
          touchAction: "auto",
        }}
      >
        <VictoryPie
          data-testid={"donut"}
          colorScale={tabColor}
          data={tabData}
          labels={() => null}
          radius={100}
          innerRadius={65}
          standalone={false}
          origin={{ x: 150, y: 100 }}
          cornerRadius={() => 2}
        />
        <VictoryLabel
          textAnchor="middle"
          style={[
            {
              fontFamily: "system-ui",
              fontSize: 32,
              fontWeight: "bold",
            },
            {
              fontFamily: "system-ui",
              fontSize: 20,
              fontWeight: "bold",
            },
          ]}
          x={150}
          y={100}
          text={[valueNPS, "%"]}
          inline
        />
      </VictoryContainer>
    </Box>
  );
};

export default RatePieChart;
